import { paytypes } from "../../common/paymentsMode"

export const tabLabels = ['Pending Delivery At My Branch', 'Pending Other Delivery At My Branch', 'Pending My Delivery At Other Branch']

export const headCellStyles = {
  borderStyle: 'solid',
  borderWidth: '0 1px 1px 0',
  borderColor: '#ccc',
  padding: '4px 6px 4px 6px',
  color: '#fff',
  fontFamily: 'Roboto',
  fontWeight: 600,
}

export const cellStyles = {
  borderStyle: 'solid',
  borderWidth: '0 1px 1px 0',
  borderColor: '#ccc',
  padding: '6px',
  fontFamily: 'Roboto',
  // fontWeight: 500,
  color:'#444444'
}
export const excelHeadCellStyles = {
  borderStyle: 'solid',
  borderWidth: '0 1px 1px 0',
  borderColor: '#ccc',
  padding: '4px 6px 4px 6px',
  color: '#444444',
  fontFamily: 'Roboto',
  fontWeight: 600,
}
export const excelCellStyles = {
  borderStyle: 'solid',
  borderWidth: '0 1px 1px 0',
  borderColor: '#ccc',
  padding: '6px',
  fontFamily: 'Roboto',
  color:'#444444',
  fontSize:'16px'
}
export const transparentStyle = (theme) => ({
  backgroundColor: 'transparent',
  boxShadow: 'none',
  marginRight: '0',
  color: theme.palette.primary.main,
  fontWeight: 'bold',
})

export const paymentTypeStyles = {
  padding: '4px 9px',
  fontSize: '12px',
  borderRadius: '30px',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  width: '6vw'
}
export const  transformData = (inputArray,commonData,loginData)=> {
  const outputArray = inputArray.map(item => ({
    intDeliveryID: 0,
    intCompanyID: loginData.intCompanyID,
    intBookingID: item.BookingID,
    strReceivedBy: commonData.ReceivedBy,  
    strIDProof: commonData.IDProof, 
    strOctroiRcptNo: item.OctroiReceiptNo,
    dtOctroiRcptDate: item.OctroiReceiptDate,
    dblOctroiRcptAmt: parseFloat(item.OctroiReceiptAmt),
    strRemarks: commonData.Remarks, 
    intUsreID: commonData.intUserID, 
    intPaymentType: commonData.PaymentType,
    strPaymentDetails: '',
    dblFreight: parseFloat(item.Freight),
    dblCollectionChg: parseFloat(item.CollectionCharges),
    dblCartage: parseFloat(item.CartageAmount),
    dblDocumentChg: parseFloat(item.DocumentCharges),
    dblInsurance: parseFloat(item.Insurance),
    dblServiceTax: parseFloat(item.ServiceTaxAmount),
    dblTotal: parseFloat(item.NetAmount),
    dblTotalDues: parseFloat(item.TotalDues),
    dblHomeDeliveryChg: parseFloat(item.HomeDeliveryChg),  //input 2 
    dblOutstanding: parseFloat(item.Outstanding),
    dblGoodsValue: parseFloat(item.GoodsValue),
    intReceivingPartyID: commonData.ReceivingPartyID,
    dblAddtitionalDeliveryCartage: parseFloat(item.AdditionalDeliveryCartage), //input 1 
    dblOctroiBrokerageAmt: parseFloat(item.OctroiBrokerageAmt),
    dblDemurrageChg: parseFloat(item.DemurrageChg), //input 4
    intIDProofid: commonData.SenderIDProofID,
    strreceiverimgurl: item.ReceiverImageURL,
    strIDProofimgurl: item.SenderIDProffUrl,
    dblLatitude: 0,
    dblLongitude: 0,
    strDeliverdLocation: "",
    IsDeliverdLocation: 0,
    dblDeliveryGST: parseFloat(item.DeliveryGST), //input 6
    strReceiverContactNo: commonData.RecMobileNo,
    dblExtraHamali: parseFloat(item.ExtraHamli), //input 3
    strVehicleNo: commonData.VehicleNo,
    strReceiverGSTN: item.ReceiverGSTN,
    strGSTPaidBy: item.ServiceTaxPaidBy,
    dblDeliveryDisc: item?.Discount||0,  //input 5 
    WalletOrderId: 0,
    GSTNState: '',
    DelGSTAmount: parseFloat(item.DeliveryGST),
    IsDeliveryRCM: 0,
    AccountNo: "",
    TransactionID: ""
  }));

  return outputArray;
}
export const excelButton = {
  color:'#0086ff'
}

export const tablefilterLabel1  = [
  [{ name: 'LR No.', id: 'LRNO', marginB: true }, { name: 'Offline LR No', id: 'ManualLRNo' }],
  [{ name: 'Payment', id: 'PaymentType', marginB: true }, { name: 'LR Due Amt.', id: 'TotalDues' }],
  [{ name: 'City', id: 'SourceCity', marginB: true }, { name: 'Branch', id: 'SourceBranch' }],
  [{ name: 'City', id: 'DestinationCity', marginB: true }, { name: 'Branch', id: 'DestinationBranch' }],
  [{ name: 'Receiver Name', id: 'RecName', marginB: true }, { name: 'Receiver No.', id: 'RecMobileNo' }],
  [{ name: 'Date', id: 'ReceiptDate', marginB: true }, { name: 'Challan No', id: 'ChallanNo' }],
  { name: 'No of Units', id: 'Units', disabled: true },
  { name: 'Cartage', id: 'CartageAmount', disabled: true },
  { name: 'Hamali', id: 'DeliveryChg', disabled: true },
  { name: 'Op. Hamali', id: 'OperatorHamaliChg', disabled: true },
  { name: 'Charges', id: 'DemurrageChg', disabled: true },
  { name: 'Discount', id: 'discount', disabled: true },
  { name: 'GST', id: 'GST', disabled: true },
  { name: 'Total', id: 'total', disabled: true },
];
export const tablefilterLabel2 = [
  { name: 'LR No.', id: 'LRNO', marginB: true },
  { name: 'Offline LR No', id: 'ManualLRNo' },
  { name: 'Payment', id: 'PaymentType', marginB: true },
  { name: 'LR Due Amt.', id: 'TotalDues' },
  { name: 'City', id: 'SourceCity', marginB: true },
  { name: 'Branch', id: 'SourceBranch' },
  { name: 'City', id: 'DestinationCity', marginB: true },
  { name: 'Branch', id: 'DestinationBranch' },
  { name: 'Receiver Name', id: 'RecName', marginB: true },
  { name: 'Receiver No.', id: 'RecMobileNo' },
  { name: 'Date', id: 'ReceiptDate', marginB: true },
  { name: 'Challan No', id: 'ChallanNo' },
  { name: 'No of Units', id: 'Units', disabled: true },
  { name: 'Cartage', id: 'CartageAmount', disabled: true },
  { name: 'Hamali', id: 'HamaliCharges', disabled: true },
  { name: 'Op. Hamali', id: 'OperatorHamaliChg', disabled: true },
  { name: 'Charges', id: 'DemurrageChg', disabled: true },
  { name: 'Discount', id: 'Discount', disabled: true },
  { name: 'GST', id: 'GST', disabled: true },
  { name: 'Total', id: 'BillAmount', disabled: true },
];

export const getTransferData = (inputArray, commonData) => {
  const outputArray = inputArray.map((data) => ({
    intBranchTransferID: 0,
    intFromCityID: data.CurrentCityID,
    intToCityID: commonData.toCity,
    intFromBranchID: data.CurrentBranchID,
    intToBranchID: commonData.BranchForDelTrans,
    intCompanyID: commonData.intCompanyID,
    strVehicleType: 'SV',
    strVehicleNo: commonData.VehicleNo,
    strTransferReason: commonData.Remarks,
    strRemarks: commonData.Remarks,
    intUserID: commonData.intUserID,
    blnDeliveryTransfer: true,
    intVehicleID: commonData.intVehicleID,
    strBookingIDs: data.BookingID,
    strLRNos: data.LRNO,
    strShortQtys: 0,
    strDamageQtys: 0,
    intDriverID: commonData.driverName,
  }))
  return outputArray
}
export const pancardValidation = (text) => {
  let regex = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
  if (regex.test(text)) {
    return true;
  }
  return false;
}

export function ValidateAadhaar(aadhaar) {
  var expr = /^([0-9]{4}[0-9]{4}[0-9]{4}$)|([0-9]{4}\s[0-9]{4}\s[0-9]{4}$)|([0-9]{4}-[0-9]{4}-[0-9]{4}$)/;
  if (!expr.test(aadhaar)) {
    return false;
  } else {
    return true
  }
}

// export const calculateFinalAmounts = dataArray => {
//   const updatedArray = dataArray.map(data => {
//     let finalAmount=0
//     if(data?.PaymentType==='ToPayDDDV'||data?.PaymentType==='TOPAY'||data?.PaymentType==='TOPAY(MANUAL)'|| data?.PaymentType==='COD'){
//       finalAmount = +Number(data?.TotalDues)+ +data.AdditionalDeliveryCartage + +data.Deliverychg + +data.ExtraHamli + +data.DemurrageChg + +data.DeliveryGST  - data.Discount
//     }else{
//       finalAmount = +Number(data.AdditionalDeliveryCartage) + +data.Deliverychg + +data.ExtraHamli + +data.DemurrageChg + +data.DeliveryGST  - data.Discount
//     }
//     return {
//       ...data,
//       finalAmount:finalAmount,
//     }
//   });
//   return updatedArray;
// };

export const calculateFinalAmounts = (dataArray) => {
  const updatedArray = dataArray.map(data => ({
    ...data,
    finalAmount: calculateAmount(data)
  }));
  return updatedArray;
};

const calculateAmount = (data) => {
  const {
    PaymentTypeID,
    TotalDues = 0,
    AdditionalDeliveryCartage = 0,
    HomeDeliveryChg = 0,
    ExtraHamli = 0,
    DemurrageChg = 0,
    DeliveryGST = 0,
    Discount = 0
  } = data;

  const totalDuesVal = +TotalDues;
  const additionalDeliveryCartageVal = +AdditionalDeliveryCartage
  const deliveryChgVal = +HomeDeliveryChg
  const extraHamliVal = +ExtraHamli
  const demurrageChgVal = +DemurrageChg
  const deliveryGSTVal = +DeliveryGST
  const discountVal = +Discount

  let finalAmount = additionalDeliveryCartageVal + deliveryChgVal + extraHamliVal + demurrageChgVal + deliveryGSTVal - discountVal
  if ([ paytypes.TO_PAY, paytypes.COD, paytypes.TO_PAY_MANUAL,paytypes.TO_PAY_DDDV].includes(PaymentTypeID)) {
    finalAmount = totalDuesVal + finalAmount
  }

  return finalAmount;
};